<template>
  <div class="moow-master-container play-background">
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container class="moow-resp-container dashboard-container">
      <div class="md-layout">
        <div class="md-layout-item">
          <rental-terms ref="rentalTermsFormRef" />
        </div>
      </div>

      <div class="md-layout mb-2">
        <div class="md-layout-item">
          <moow-button :type="['dark', 'outlined', 'flat']" btnText="Back" @mClick="back" />
        </div>
        <div class="md-layout-item" style="text-align:right">
          <moow-button :type="['light']" btnText="Next" @mClick="next" :loading="validating" />
        </div>
      </div>
    </b-container>

    <moow-dialog-confirm
      title="Confirm information"
      content="Ensure all information until now is correct or go back to edit."
      confirmText="Confirm"
      cancelText="Wait"
      :showDialog="confirmDialog"
      @mConfirm="onConfirm"
      @mCancel="confirmDialog=false"
    />

    <error-snackbar
      :message="snackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showSnackbar"
      position="center"
      :isInfinity="false"
    ></error-snackbar>
  </div>
</template>

<script>
import PropertySelector from "@/components/property/propertySelector.vue";
import Snackbar from "@/components/snackbar.vue";
import RentalTerms from "@/components/bookings/deals/rentalTerms.vue";

export default {
  props: {},
  components: {
    "error-snackbar": Snackbar,
    "property-selector": PropertySelector,
    "rental-terms": RentalTerms,
  },
  data() {
    return {
      confirmDialog: false,
      loading: false,
      snackbarMessage: "",
      showSnackbar: false,
      validating: false,
    };
  },
  filters: {},
  mounted() {},
  created() {},
  watch: {},
  computed: {},
  methods: {
    async next() {
      this.validating = true;
      var v = await this.$refs.rentalTermsFormRef.validateForm();
      this.validating = false;

      if (v) {
        this.confirmDialog = true;
      } else {
        window.scrollTo(0, 0);
      }
    },
    back() {
      this.changeView("dealApplicationLessor");
    },
    onConfirm() {
      this.changeView("dealApplicationDecision");
    },
    displayMessage(message) {
      this.snackbarMessage = message;
      this.showSnackbar = true;
    },
    changeView(name, params) {
      this.$router.push({
        name: name,
        params: params,
      });
    },
  },
};
</script>
<style scoped>
@import "../../../assets/styles/booking.css";
@import "../../../assets/styles/dashboard.css";
@import "../../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/bookings/deals/DealApplicationTerms.vue